export const categorias = [
{
    categoria:'Ropa',
    subcategorias:[
        'Remeras',
        'Camisas',
        'Pantalones',
        'Buzos',
        'Camperas',
        'Sweters',
        'Bermudas',
        'Mayas',
        'Ropa deportiva',
        'Ropa interior',
    ]
},
{
    categoria:'Calzado',
    subcategorias:[
        'Zapatillas',
        'Zapatos',
        'Ojotas y sandalias',
    ]
},
{
    categoria:'Accesorios',
    subcategorias:[
        'Aros',
        'Collares',
        'Llaveros',
    ]
},
{
    categoria:'Marroquineria',
    subcategorias:[
        'Bolsos',
        'Mochilas',
        'Billeteras',
        'Riñoneras',
    ]
},]